import {CashBoxStatus} from "./CashBoxStatus";

export const CashBoxStatusNames: Record<CashBoxStatus, string> = {
  [CashBoxStatus.IN_PROGRESS]: "En Progreso",
  [CashBoxStatus.SENT]: "Enviada",
  [CashBoxStatus.CONFIRM]: "Confirmada",
  [CashBoxStatus.REPORT_SUBMITTED]: "Rendicion Enviada",
  [CashBoxStatus.TO_FIX]: "A Corregir",
  [CashBoxStatus.CLOSE]: "Cerrada",
};
